goog.provide("shadow.js.shim.module$$mui$material$Tooltip$default");
shadow.js.shim.module$$mui$material$Tooltip$default = shadow.js.require(540, {})["default"];
